import { render, staticRenderFns } from "./CloudImg.vue?vue&type=template&id=212b018d"
import script from "./CloudImg.vue?vue&type=script&lang=js"
export * from "./CloudImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports